import { autoinject, Aurelia } from 'aurelia-framework';
import { AuthService } from 'aurelia-authentication';
import { AppRouter } from 'aurelia-router';

@autoinject
export class Logout{
	constructor(
		private authService: AuthService,
		private appRouter: AppRouter,
		private aurelia: Aurelia	) {

	}

	created() {
		this.authService.logout();	
	}
    

}